// Default entities for tracking events
export const DEFAULT_ENTITIES = ['organization', 'user']

// Default version for tracking events
export const DEFAULT_VERSION = 1

export const TRACKING_EVENT_NAMES = {
  ACCOUNT_DOWNGRADE_TO_FREE_SURVEY: 'account_downgrade_to_free_survey',
  ACCOUNT_DOWNGRADE_TO_FREE_SURVEY_V2: 'account_downgrade_to_free_survey_v2',
  ADA_CLICKED: 'ADA Clicked',
  AI_NOTETAKER_ENGAGED: 'AI Notetaker Engaged',
  AI_NOTETAKER_INTERACTION: 'AI Notetaker Interaction',
  AI_OUTPUT_REVIEWED: 'AI Output Reviewed',
  AI_RESPONDED: 'AI Responded',
  AVAILABILITY_INTERACTION: 'Availability Interaction',
  AVAILABILITY_RULE_CREATED: 'Availability Rule Created',
  AVAILABILITY_RULE_UPDATED: 'Availability Rule Updated',
  BILLING_TERM_TOGGLED: 'Billing Term Toggled',
  BOOKING_CODE_MANAGEMENT: 'Booking Code Management',
  BOOKING_FINGERPRINT_RETRIEVED: 'Booking Fingerprint Retrieved',
  BOOKING_PAGE_SHARED: 'Booking Page Shared',
  BOOKING_PAGE_SHARED_V2: 'Booking Page Shared V2',
  BOOKING_PAGE_VIEWED: 'Booking Page Viewed',
  CTA_CLICKED: 'CTA Clicked',
  CTA_SHOWN: 'CTA Shown',
  CALENDLY_ASSIST_ENGAGED: 'Calendly Assist Engaged',
  CHECKOUT_FLOW_STARTED: 'Checkout Flow Started',
  CONTACT_INTERACTION: 'Contact Interaction',
  CONTACT_UPDATED: 'Contact Updated',
  DATA_EXPORTED: 'Data Exported',
  DOMAIN_CONTROL_CREATED: 'Domain Control Created',
  DOMAIN_CONTROL_ENFORCED: 'Domain Control Enforced',
  DOMAIN_CONTROL_UPDATED: 'Domain Control Updated',
  DROPDOWN_OPENED: 'Dropdown Opened',
  DROPDOWN_SELECTED: 'Dropdown Selected',
  EMAIL_CONFIRMED: 'Email Confirmed',
  ERROR_STATE_SHOWN: 'Error State Shown',
  EVENT_BAR_SHOWN: 'Event Bar Shown',
  EVENT_NOTIFICATION_REJECTED: 'Event Notification Rejected',
  EVENT_NOTIFICATION_SUBSCRIPTION_UPDATED: 'Event Notification Subscription Updated',
  EVENT_NOTIFICATION_TRIGGERED: 'Event Notification Triggered',
  EVENT_TYPE_CREATED: 'Event Type Created',
  EVENT_TYPE_EDITOR_INTERACTION: 'Event Type Editor Interaction',
  EVENT_TYPE_EDITOR_OPEN: 'Event Type Editor Open',
  EVENT_TYPE_UPDATED: 'Event Type Updated',
  EXTENSION_SIDEBAR_LOADED: 'Extension Sidebar Loaded',
  EXTERNAL_APP_COMMAND_RAN: 'External App Command Ran',
  EXTERNAL_APP_INSTALLED: 'External App Installed',
  EXTERNAL_APP_UNINSTALLED: 'External App Uninstalled',
  EXTERNAL_LINK_ENGAGED: 'External Link Engaged',
  FEATURE_FLAG_ENCOUNTERED: 'Feature Flag Encountered',
  FLOW_STARTED: 'Flow Started',
  FLOW_STEP_CLICKED: 'Flow Step Clicked',
  FLOW_STEP_COMPLETED: 'Flow Step Completed',
  INTEGRATION_CONFIGURATION_UPDATED: 'Integration Configuration Updated',
  INTEGRATION_CONNECTED: 'Integration Connected',
  INTEGRATION_CONNECTION_FAILED: 'Integration Connection Failed',
  INTEGRATION_DISCONNECTED: 'Integration Disconnected',
  INTEGRATION_MODAL_CLICKED: 'Integration Modal Clicked',
  INTEGRATION_NOTIFICATION_PREFERENCES_UPDATED: 'Integration Notification Preferences Updated',
  INTEGRATION_STARTED: 'Integration Started',
  INVITEE_BOOKED: 'Invitee Booked',
  INVITEE_CANCELED: 'Invitee Canceled',
  KEYWORD_DETECTED: 'Keyword Detected',
  LOCALIZED_PRICING_SELECTED: 'Localized Pricing Selected',
  MEETING_HISTORY_VIEWED: 'Meeting History Viewed',
  MEETING_HOURS_UPDATED: 'Meeting Hours Updated',
  MEETING_INTERACTION: 'Meeting Interaction',
  MEETING_RECAP_INTERACTION: 'Meeting Recap Interaction',
  MEETING_RECAP_SHARED: 'Meeting Recap Shared',
  MEETING_RECAP_VIEWED: 'Meeting Recap Viewed',
  MODAL_INTERACTION: 'Modal Interaction',
  NAVIGATION_LINK_CLICKED: 'Navigation Link Clicked',
  ORGANIZATION_INTEGRATION: 'Organization Integration',
  ORGANIZATION_INVITATION_LINK_SHARED: 'Organization Invitation Link Shared',
  ORGANIZATION_INVITATION_SENT: 'Organization Invitation Sent',
  ORGANIZATION_MEMBER_ADDED: 'Organization Member Added',
  ORGANIZATION_MEMBER_REMOVED: 'Organization Member Removed',
  ORGANIZATION_MEMBERSHIP_REQUESTED: 'Organization Membership Requested',
  ORGANIZATION_SETTING_UPDATED: 'Organization Setting Updated',
  ORGANIZATION_UPDATED: 'Organization Updated',
  PAYMENT_METHOD_DETECTED: 'Payment Method Detected',
  PAYWALL_SHOWN: 'Paywall Shown',
  PERMISSIONS_UPDATED: 'Permissions Updated',
  POLL_VOTE_RECORDED: 'Poll Vote Recorded',
  PUSH_NOTIFICATION_INTERACTION: 'Push Notification Interaction',
  RSVP_RECORDED: 'RSVP Recorded',
  RECAPTCHA_INTERACTION: 'ReCaptcha Interaction',
  REPORTING_CONFIGURED: 'Reporting Configured',
  REPORTING_VIEWED: 'Reporting Viewed',
  ROUTING_FORM_COMPLETED: 'Routing Form Completed',
  ROUTING_FORM_CREATED: 'Routing Form Created',
  ROUTING_FORM_UPDATED: 'Routing Form Updated',
  SCHEDULE_IN_REAL_TIME: 'Schedule in Real Time',
  SEARCH_INTERACTION: 'Search Interaction',
  SEARCH_PERFORMED: 'Search Performed',
  SEND_VIA_CALENDLY: 'Send Via Calendly',
  SETTING_UPDATED: 'Setting Updated',
  SIGNED_IN: 'Signed In',
  SUBSCRIPTION_CREATED: 'Subscription Created',
  SUBSCRIPTION_UPDATED: 'Subscription Updated',
  SURVEY_COMPLETED: 'Survey Completed',
  SURVEY_SHOWN: 'Survey Shown',
  TABLE_INTERACTION: 'Table Interaction',
  TOOLTIP_CLICKED: 'Tooltip Clicked',
  TOOLTIP_SHOWN: 'Tooltip Shown',
  TRIAL_ENDED: 'Trial Ended',
  TRIAL_EXTENDED: 'Trial Extended',
  TRIAL_STARTED: 'Trial Started',
  USER_ACTION_CAPTURED: 'User Action Captured',
  USER_CREATED: 'User Created',
  USER_DELETED: 'User Deleted',
  USER_FINGERPRINT_RETRIEVED: 'User Fingerprint Retrieved',
  USER_GROUP_CREATED: 'User Group Created',
  WORKFLOW_ACTION_TRIGGERED: 'Workflow Action Triggered',
  WORKFLOW_ASSIGNMENT_UPDATED: 'Workflow Assignment Updated',
  WORKFLOW_CREATED: 'Workflow Created',
  WORKFLOW_UPDATED: 'Workflow Updated',
}

// Valid location values for Contact Interaction tracking events
// Reference: https://analytics-docs.calendly-internal.com/event-definitions/contact_interaction/
export const CONTACT_INTERACTION_LOCATIONS = {
  MEETINGS_PAGE_RIGHT_RAIL: 'meetings_page_right_rail',
  CONTACT_HOVER_CARD_MEETINGS_RIGHT_RAIL: 'contact_hover_card_meetings_right_rail',
  ASK_CALENDLY_CHAT: 'ask_calendly_chat',
  CONTACT_HOVER_CARD_ASK_CALENDLY_CHAT: 'contact_hover_card_ask_calendly_chat'
}
